import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Accordion, Card, Button } from 'react-bootstrap';

const AccordionCollapse = (props) => {
  const { terms } = props;

  const handelClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  return (
    <Accordion className="text-left collapse show">
      <Card>
        <Accordion.Toggle
          as={Button}
          variant="link"
          eventKey="0"
          className="p-15 text-left not-link"
          onClick={handelClick}>
          Ver Términos y Condiciones
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            <ReactMarkdown>{ terms }</ReactMarkdown>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

AccordionCollapse.propTypes = {
  terms: PropTypes.string.isRequired,
};

export default AccordionCollapse;
